/* =====================================================
   RIDGELINE ROASTERS — SHOPIFY THEME JS
   ===================================================== */

/* --- Theme Toggle --- */
(function () {
  const r = document.documentElement;
  const toggles = document.querySelectorAll('[data-theme-toggle]');
  let theme = localStorage.getItem('rl-theme') || 'dark';
  r.setAttribute('data-theme', theme);

  function updateIcon(btn) {
    btn.innerHTML = theme === 'dark'
      ? `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>`
      : `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>`;
    btn.setAttribute('aria-label', `Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`);
  }

  toggles.forEach(t => {
    updateIcon(t);
    t.addEventListener('click', () => {
      theme = theme === 'dark' ? 'light' : 'dark';
      r.setAttribute('data-theme', theme);
      localStorage.setItem('rl-theme', theme);
      toggles.forEach(b => updateIcon(b));
    });
  });
})();

/* --- Sticky Nav --- */
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
})();

/* --- Hero Parallax --- */
(function () {
  const bg = document.querySelector('.hero__bg');
  if (!bg) return;
  window.addEventListener('scroll', () => {
    bg.style.transform = `scale(1.05) translateY(${window.scrollY * 0.25}px)`;
  }, { passive: true });
})();

/* --- Mobile Nav --- */
(function () {
  const toggle = document.querySelector('.nav-toggle');
  const overlay = document.querySelector('.mobile-nav');
  if (!toggle || !overlay) return;
  let open = false;

  function openNav() {
    open = true;
    overlay.classList.add('open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const spans = toggle.querySelectorAll('span');
    spans[0].style.transform = 'translateY(7px) rotate(45deg)';
    spans[1].style.opacity = '0';
    spans[2].style.transform = 'translateY(-7px) rotate(-45deg)';
  }

  function closeNav() {
    open = false;
    overlay.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    const spans = toggle.querySelectorAll('span');
    spans[0].style.transform = '';
    spans[1].style.opacity = '';
    spans[2].style.transform = '';
  }

  toggle.addEventListener('click', () => open ? closeNav() : openNav());

  overlay.querySelectorAll('a').forEach(a => a.addEventListener('click', closeNav));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && open) closeNav();
  });
})();

/* --- Cart Drawer --- */
(function () {
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-drawer__overlay');
  const closeBtn = document.querySelector('.cart-drawer__close');
  const cartBtns = document.querySelectorAll('[data-open-cart]');
  if (!drawer) return;

  function openCart() {
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);
})();

/* --- Variant Selection --- */
(function () {
  document.querySelectorAll('.product-variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.product-variants__options');
      if (group) group.querySelectorAll('.product-variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
})();

/* --- Quantity Selector --- */
(function () {
  document.querySelectorAll('.quantity-selector').forEach(sel => {
    const input = sel.querySelector('input');
    sel.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        let val = parseInt(input.value) || 1;
        if (btn.dataset.action === 'plus') val = Math.min(val + 1, 99);
        if (btn.dataset.action === 'minus') val = Math.max(val - 1, 1);
        input.value = val;
      });
    });
  });
})();

/* --- Email Signup --- */
(function () {
  document.querySelectorAll('[data-signup-form]').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const confirm = form.parentElement.querySelector('.email-signup__confirm');
      form.querySelector('input').value = '';
      if (confirm) {
        confirm.style.display = 'block';
        setTimeout(() => { confirm.style.display = 'none'; }, 5000);
      }
    });
  });
})();

/* --- Coffee Finder Quiz --- */
(function () {
  const overlay = document.querySelector('.quiz-overlay');
  if (!overlay) return;

  let currentStep = 1;
  const TOTAL_STEPS = 5;
  const answers = {};

  /* ── Coffee profiles — Ridgeline real products ──────────────────── */
  const coffeeProfiles = [
    {
      id: 'light',
      name: 'Light Roast',
      origin: 'Nicaragua · Highland · Washed',
      notes: 'Bright · Citrus · Floral · Clean Finish',
      handle: 'ridgeline-12oz-light-roast-coffee',
      tags: { flavor: ['fruit', 'complex'], roast: ['light'], brew: ['ritual', 'cold'], persona: ['adventurer', 'purist'], style: ['black'] }
    },
    {
      id: 'natural',
      name: 'Natural Processed',
      origin: 'Nicaragua · Highland · Natural',
      notes: 'Fruity · Wine-Like · Bold · Complex',
      handle: 'ridgeline-12oz-natural-processed-coffee',
      tags: { flavor: ['fruit', 'complex'], roast: ['light'], brew: ['ritual', 'cold'], persona: ['adventurer'], style: ['black'] }
    },
    {
      id: 'medium',
      name: 'Medium Roast',
      origin: 'Nicaragua · Highland · Washed',
      notes: 'Smooth · Nutty · Caramel · Balanced',
      handle: 'ridgeline-12oz-medium-roasted-coffee',
      tags: { flavor: ['nutty'], roast: ['medium'], brew: ['ritual', 'drip', 'cold'], persona: ['purist', 'social'], style: ['black', 'milk'] }
    },
    {
      id: 'mediumdark',
      name: 'Medium Dark Roast',
      origin: 'Nicaragua · Highland · Washed',
      notes: 'Dark Chocolate · Brown Sugar · Bold · Rich',
      handle: 'ridgeline-12oz-medium-roast-coffee',
      tags: { flavor: ['chocolate', 'nutty'], roast: ['dark'], brew: ['drip', 'espresso'], persona: ['social', 'fuel'], style: ['milk', 'sweet'] }
    },
    {
      id: 'seasonal',
      name: 'Seasonal Blend',
      origin: 'Nicaragua · Seasonal Sourcing',
      notes: 'Rotating · Bright & Sweet · Crowd-Pleasing',
      handle: 'ridgeline-12oz-seasonal-blend',
      tags: { flavor: ['fruit', 'nutty'], roast: ['medium'], brew: ['cold', 'drip'], persona: ['adventurer', 'social'], style: ['sweet', 'latte'] }
    },
    {
      id: 'dark',
      name: 'Dark Roast',
      origin: 'Nicaragua · Highland · Washed',
      notes: 'Bold · Smoky · Full-Bodied · Deep',
      handle: 'ridgeline-12oz-dark-roast-coffee',
      tags: { flavor: ['chocolate'], roast: ['dark'], brew: ['drip', 'espresso'], persona: ['social', 'fuel'], style: ['milk', 'latte'] }
    },
    {
      id: 'espresso',
      name: 'Espresso Blend',
      origin: 'Nicaragua · Espresso Roast',
      notes: 'Thick Crema · Chocolate · Toffee · Intense',
      handle: 'ridgeline-12oz-espresso-blend-coffee',
      tags: { flavor: ['chocolate'], roast: ['dark'], brew: ['espresso'], persona: ['purist', 'fuel'], style: ['latte', 'sweet'] }
    },
    {
      id: 'decaf',
      name: 'Decaf',
      origin: 'Nicaragua · Swiss Water Process',
      notes: 'Smooth · Chocolate · No Caffeine · Full Flavor',
      handle: 'ridgeline-12oz-decaffeinated-coffee',
      tags: { flavor: ['chocolate', 'nutty'], roast: ['medium'], brew: ['drip', 'cold'], persona: ['social', 'fuel'], style: ['sweet', 'milk'] }
    }
  ];

  const reasons = {
    light:      "You\'re a purist who wants the full origin story in the cup. Our Light Roast lets Nicaragua\'s highland terroir shine — bright, clean, and complex without anything getting in the way.",
    natural:    "You chase the unexpected. Our Natural Processed is fermented on the cherry, which gives it a wild, wine-like depth that most coffees don\'t even attempt. Made for the curious.",
    medium:     "You want great coffee that never lets you down. Our Medium Roast is smooth, balanced, and endlessly drinkable — the kind of coffee you reach for every single morning without thinking twice.",
    mediumdark: "You want boldness with refinement. Our Medium Dark Roast hits that sweet spot — deep chocolate and brown sugar notes with enough body to power through anything the day throws at you.",
    seasonal:   "You love variety and you\'re open to wherever the season takes you. Our Seasonal Blend changes with the harvest, keeping every bag a little bit of a surprise.",
    dark:       "You run on it. Our Dark Roast is roasted deep for maximum body, boldness, and the kind of full-throated flavor that actually wakes you up. No apologies.",
    espresso:   "The machine matters to you. Our Espresso Blend is pulled to perfection — thick crema, intense chocolate-toffee flavor, and the precision that espresso drinkers demand.",
    decaf:      "You love the ritual and the flavor, but you\'re watching the caffeine. Our Decaf doesn\'t cut corners — Swiss Water Process keeps the depth while keeping you sleeping tonight."
  };

  /* ── DOM refs ────────────────────────────────────────────────────── */
  const form       = overlay.querySelector('#coffee-quiz-form');
  const nextBtn    = overlay.querySelector('#quiz-next');
  const prevBtn    = overlay.querySelector('#quiz-prev');
  const resultEl   = overlay.querySelector('#quiz-result');
  const progressFill  = overlay.querySelector('#quiz-progress-fill');
  const progressLabel = overlay.querySelector('#quiz-progress-label');

  /* ── Helpers ─────────────────────────────────────────────────────── */
  function getAllSteps() {
    return Array.from(overlay.querySelectorAll('.quiz-step'));
  }

  function updateProgress(step) {
    const pct = Math.round(((step - 1) / TOTAL_STEPS) * 100);
    if (progressFill)  progressFill.style.width = pct + '%';
    if (progressLabel) progressLabel.textContent = `Question ${step} of ${TOTAL_STEPS}`;
  }

  function showStep(n) {
    // Hide result panel
    if (resultEl) {
      resultEl.hidden = true;
      resultEl.classList.remove('active');
    }

    // Show the correct fieldset via .active class (CSS hides steps without .active)
    getAllSteps().forEach(el => {
      const isTarget = parseInt(el.dataset.step) === n;
      el.classList.toggle('active', isTarget);
      // Also manage hidden for accessibility
      el.hidden = !isTarget;
    });

    // Prev button — show only from step 2 onward
    if (prevBtn) prevBtn.hidden = n <= 1;

    // Next button label — last step says "See My Result"
    if (nextBtn) {
      nextBtn.hidden = false;
      nextBtn.textContent = n === TOTAL_STEPS ? 'See My Result →' : 'Next →';
      // Enable only if the current question already has an answer
      const stepEl = overlay.querySelector(`[data-step="${n}"]`);
      const qName  = stepEl ? stepEl.dataset.question : null;
      nextBtn.disabled = qName ? !answers[qName] : false;
    }

    updateProgress(n);
  }

  /* ── Scoring ─────────────────────────────────────────────────────── */
  function scoreProfiles() {
    return coffeeProfiles
      .map(p => {
        let score = 0;
        if (answers.flavor  && p.tags.flavor.includes(answers.flavor))   score += 3;
        if (answers.roast   && p.tags.roast.includes(answers.roast))     score += 2;
        if (answers.brew    && p.tags.brew.includes(answers.brew))       score += 2;
        if (answers.persona && p.tags.persona.includes(answers.persona)) score += 2;
        if (answers.style   && p.tags.style  && p.tags.style.includes(answers.style))   score += 1;
        return { coffee: p, score };
      })
      .sort((a, b) => b.score - a.score)[0].coffee;
  }

  function showResult() {
    // Fill the progress bar to 100%
    if (progressFill)  progressFill.style.width = '100%';
    if (progressLabel) progressLabel.textContent = `${TOTAL_STEPS} of ${TOTAL_STEPS}`;

    // Hide all steps
    getAllSteps().forEach(el => {
      el.hidden = true;
      el.classList.remove('active');
    });
    if (nextBtn) nextBtn.hidden = true;
    if (prevBtn) prevBtn.hidden = true;

    const match = scoreProfiles();

    // Populate result panel — supports both old and new element id schemes
    const set = (id, val) => { const el = overlay.querySelector(id); if (el) el.textContent = val; };
    const setHref = (id, val) => { const el = overlay.querySelector(id); if (el) el.href = val; };

    set('#quiz-result-badge',  match.origin);
    set('#quiz-result-name',   match.name);
    set('#quiz-result-origin', match.notes);
    set('#quiz-result-note',   reasons[match.id] || '');
    setHref('#quiz-result-cta', `/products/${match.handle}`);

    if (resultEl) {
      resultEl.hidden = false;
      resultEl.classList.add('active');
    }
  }

  /* ── Open / close ────────────────────────────────────────────────── */
  function openQuiz() {
    currentStep = 1;
    Object.keys(answers).forEach(k => delete answers[k]);
    overlay.classList.add('open');
    overlay.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    // Reset all steps to their initial state
    getAllSteps().forEach(el => {
      el.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });
      el.classList.remove('active');
      el.hidden = true;
    });
    if (resultEl) {
      resultEl.hidden = true;
      resultEl.classList.remove('active');
    }
    if (nextBtn)  nextBtn.hidden  = false;
    showStep(1);
  }

  function closeQuiz() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-open-quiz]').forEach(btn => {
    btn.addEventListener('click', e => { e.preventDefault(); openQuiz(); });
  });

  overlay.querySelectorAll('[data-close-quiz]').forEach(btn => {
    btn.addEventListener('click', closeQuiz);
  });
  overlay.addEventListener('click', e => {
    if (e.target === overlay || e.target.classList.contains('quiz-modal__backdrop')) closeQuiz();
  });

  /* ── Option selection ────────────────────────────────────────────── */
  // Delegate on the overlay so it works regardless of when the DOM loads
  overlay.addEventListener('change', e => {
    const radio = e.target;
    if (radio.type !== 'radio') return;

    const stepEl = radio.closest('.quiz-step');
    if (!stepEl) return;

    const qName = stepEl.dataset.question;
    answers[qName] = radio.value;

    // Enable the Next button now that this step has an answer
    if (nextBtn) nextBtn.disabled = false;
  });

  // Also handle click on the card label for visual feedback
  overlay.addEventListener('click', e => {
    const card = e.target.closest('.quiz-option__card');
    if (!card) return;
    const label = card.closest('.quiz-option');
    if (!label) return;
    const stepEl = label.closest('.quiz-step');
    if (!stepEl) return;
    // Clear selected style from siblings, add to this one
    stepEl.querySelectorAll('.quiz-option').forEach(o => o.classList.remove('selected'));
    label.classList.add('selected');
  });

  /* ── Navigation ──────────────────────────────────────────────────── */
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (nextBtn.disabled) return;
      if (currentStep < TOTAL_STEPS) {
        currentStep++;
        showStep(currentStep);
      } else {
        showResult();
      }
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (currentStep > 1) {
        currentStep--;
        showStep(currentStep);
      }
    });
  }

  /* ── Retake ──────────────────────────────────────────────────────── */
  const retakeBtn = overlay.querySelector('#quiz-retake');
  if (retakeBtn) {
    retakeBtn.addEventListener('click', () => {
      if (nextBtn) nextBtn.hidden = false;
      openQuiz();
    });
  }

  /* ── Keyboard close ──────────────────────────────────────────────── */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('open')) closeQuiz();
  });
})();


/* --- Smooth scroll --- */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
